import { ImCheckmark } from 'react-icons/im';
import { motion } from 'framer-motion';
import { FaExclamationCircle } from 'react-icons/fa';

const Checkboxbtn = ({ name, platform, logo, status, active, disconnected }) => {
  const handleImageError = (event, platform) => {
    event.target.src = `${process.env.PUBLIC_URL}/socials/${platform}-logo.svg`;
  };

  const randomDelay = Math.random();

  return (
    <div className='flex flex-col items-center w-full cursor-pointer'>
      <div className={`relative w-[50px] mx-auto border-[3px] rounded-full p-1 ${active ? 'border-purple-500' : disconnected ? 'border-red-500' : 'border-gray-300'}`}>
        {status && <ImCheckmark size={20} color='green' className='absolute top-[-5px] right-[-5px] z-20 bg-white rounded-full' />}
        {disconnected && 
          <FaExclamationCircle 
            size={15} 
            color='red' 
            className='absolute top-[-5px] right-[-5px] z-20 bg-white rounded-full'
            title='Account disconnected. Click to reconnect.'
          />
        }
        <img
          src={!platform ? `${process.env.PUBLIC_URL}/no-thumbnail.png` : `${process.env.PUBLIC_URL}/socials/${platform}-logo.svg`}
          alt="social"
          className="absolute w-[20px] bottom-2 right-0 z-10 bg-white p-1 rounded-full"
        />

        <motion.div
          animate={
            active
              ? { y: 0, opacity: 1 }
              : { y: [0, -20, 0], opacity: [1, 0.3, 1] }
          }
          transition={
            active
              ? { duration: 0 }
              : {
                duration: 1,
                delay: randomDelay,
                ease: 'easeInOut',
                repeat: 3,
                repeatType: 'loop'
              }
          }
        >
          <img
            src={!logo ? '' : `${logo}`}
            onError={(e) => handleImageError(e, platform)}
            alt="Creator Avatar"
            className="z-99 w-full rounded-full"
          />
        </motion.div>
      </div>

      <div className="text-center text-[12px] max-w-[60px] truncate mx-auto">
        {name}
      </div>
    </div>
  );
};

export default Checkboxbtn;
